import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from './api';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [setupNeeded, setSetupNeeded] = useState(false);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem('gems_admin_token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get('/auth/me');
      setAdmin(data);
    } catch (e) {
      localStorage.removeItem('gems_admin_token');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/auth/setup-needed');
        setSetupNeeded(!!data.setup_needed);
      } catch (e) {
        // ignore
      }
      await loadMe();
    })();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('gems_admin_token', data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post('/auth/register', { name, email, password });
    localStorage.setItem('gems_admin_token', data.token);
    setAdmin(data.admin);
    setSetupNeeded(false);
    return data.admin;
  };

  const logout = () => {
    localStorage.removeItem('gems_admin_token');
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, setupNeeded, login, register, logout, refresh: loadMe }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used inside AdminAuthProvider');
  return ctx;
}
